import { c as _c } from "react/compiler-runtime";
import { ProductPriceDefault } from './product-price-default';
import { ProductPriceRange } from './product-price-range';
type ProductPriceDefaultProps = {
  className?: string;
  originalPrice?: string;
  price: string;
  type: 'default';
};
type ProductPriceRangeProps = {
  className?: string;
  fromPrice: string;
  isOnSale?: boolean;
  toPrice: string;
  type: 'range';
};
export type ProductPriceDisplayProps = ProductPriceDefaultProps | ProductPriceRangeProps;
export function ProductPriceDisplay(props) {
  const $ = _c(9);
  if (props.type === "range") {
    let t0;
    if ($[0] !== props.className || $[1] !== props.fromPrice || $[2] !== props.isOnSale || $[3] !== props.toPrice) {
      t0 = <ProductPriceRange className={props.className} fromPrice={props.fromPrice} isOnSale={props.isOnSale} toPrice={props.toPrice} />;
      $[0] = props.className;
      $[1] = props.fromPrice;
      $[2] = props.isOnSale;
      $[3] = props.toPrice;
      $[4] = t0;
    } else {
      t0 = $[4];
    }
    return t0;
  }
  let t0;
  if ($[5] !== props.className || $[6] !== props.originalPrice || $[7] !== props.price) {
    t0 = <ProductPriceDefault className={props.className} originalPrice={props.originalPrice} price={props.price} />;
    $[5] = props.className;
    $[6] = props.originalPrice;
    $[7] = props.price;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  return t0;
}